<template>
  <div class="addmarket">
    <div class="addmarket--header">
      <div class="addmarket--header--title">
        <div class="title--back iconfont" @click="$router.go(-1)">&#xe600;</div>
        <div class="title--text" >新增资产</div>
        <div class="title--back" ></div>
      </div>
    </div>
    <div class="header-line"></div>
    <div class="addmarket--info">
      <div class="addmarket--info--name">
        <div class="item--name">资产名称</div>
        <input type="text" class="item--ipt" placeholder="请输入资产名称" v-model="assetsName">
      </div>
      <div class="addmarket--info--name">
        <div class="item--name">资产保管位置</div>
        <input type="text" class="item--ipt" placeholder="请输入资产保管位置" v-model="assetsLoc">
      </div>
      <div class="addfollowup--info--item" @click="handleToGetAssetsType">
        <div class="item--text">资产类型</div>
        <div class="item--desc">{{assetsText?assetsText:'点击选择'}}</div>
        <div class="item--icon iconfont">&#xe62c;</div>
      </div>
      <div class="addmarket--info--name">
        <div class="item--name">抵债金额(万元)</div>
        <input type="text" class="item--ipt" placeholder="请输入抵债金额" v-model="assetsAmount">
      </div>
      <div class="addfollowup--info--person">
        <div class="item--persons--title">项目经理</div>
        <div class="item--persons--desc">
          <div
            class="desc--person"
            v-for="(item,index) in assetsManagerList"
            :key="item.actorno+index"
          >{{item.actorname}}</div>
          <div
            class="desc--person desc--person--plus iconfont"
            @click="handleToAssetsManager"
          >&#xe602;</div>
        </div>
      </div>
    </div>
    <div class="addfollowup--footer" v-if="!assetsManagerFlag">
      <div class="addfollowup--footer--save" @click="handleToAddAssetsCheckNews">保存</div>
    </div>
    <div class="addfollowup--visit" v-if="assetsManagerFlag">
      <div class="visit--title">
        <div class="visit--title--cancle"></div>
        <div class="visit--title--text">选择项目经理</div>
        <div class="visit--title--cancle" @click.stop.prevent="handleToCompleteAssetsManager">完成</div>
      </div>
      <div class="visit--line"></div>
      <div class="visit--person">
        <div
          class="visit--person--content"
          :class="{active:assetsSelectTag.includes(item.actorno)}"
          v-for="item in assetsManagerAllList"
          :key="item.actorno"
          @click.stop.prevent="handleToAddAssetsManager(item)"
        >{{item.actorname}}</div>
      </div>
    </div>
    <van-popup
      v-model="assetsTypeFlag"
      :close-on-click-overlay="false"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        title="选择跟进方式"
        show-toolbar
        :visible-item-count="2"
        :columns="assetsTypeTextList"
        :default-index="0"
        @cancel="handleToFollowCancleFloat"
        @confirm="handleToSelectVisitMode"
      />
    </van-popup>
  </div>
</template>

<script type="text/ecmascript-6">
import { get, postjson } from '../api/api'

export default {
  name: 'AddAssets',
  data () {
    return {
      assetsName: '', // 资产名称
      assetsLoc: '', // 资产位置
      assetsType: '', // 资产类型
      assetsText: '', // 资产类型文本
      assetsAmount: '', // 资产金额
      assetsManagerFlag: false, // 控制项目经理页面显示
      assetsSelectTag: [], // 选中项目经理actorno
      assetsManagerList: [], // 已选中项目经理列表
      assetsManagerAllList: [], // 所有项目经理列表
      assetsTypeFlag: false, // 控制选择资产类型页面显示
      assetsTypeList: [], // 所有资产类型
      assetsTypeTextList: [] // 所有资产类型文本列表
    }
  },
  beforeMount () {
    this.handleToItemPerson()
  },
  methods: {
    // 获取项目经理
    async handleToAssetsManager () {
      const result = await get('/api/CBMS-APP/sUser/listByComBrIdAndDuty', { dutyno: '0129' })
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.assetsManagerFlag = true
        this.assetsManagerAllList = result.data.records
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 添加项目经理人员
    handleToAddAssetsManager (itemObj) {
      if (this.assetsSelectTag.includes(itemObj.actorno)) {
        this.assetsSelectTag.splice(this.assetsSelectTag.indexOf(itemObj.actorno), 1)
        this.assetsManagerList = this.assetsManagerList.filter(item => item.actorno !== itemObj.actorno)
      } else {
        this.assetsManagerList.push({
          actorname: itemObj.actorname,
          actorno: itemObj.actorno
        })
        this.assetsSelectTag.push(itemObj.actorno)
      }
    },
    // 完成项目经理人员选择
    handleToCompleteAssetsManager () {
      document.body.style.overflow = 'auto'
      this.assetsManagerFlag = false
    },
    // 添加登陆人到项目成员
    handleToItemPerson () {
      this.assetsManagerList.push({
        actorname: this.$cookies.get('actorname'),
        actorno: this.$cookies.get('actorno')
      })
      this.assetsSelectTag.push(this.$cookies.get('actorno'))
    },
    // 获取资产类型
    async handleToGetAssetsType () {
      this.assetsTypeTextList = []
      const result = await get('/api/CBMS-APP/sDic/getOpttypeList', {
        opttype: 'STD_ZCYY_OPER_TYPE'
      })
      if (result.success) {
        document.body.style.overflow = 'hidden'
        this.assetsTypeFlag = true
        this.assetsTypeList = result.data
        result.data.forEach(item => {
          this.assetsTypeTextList.push(item.cnname)
        })
      } else {
        this.$toast.success('加载数据出错')
      }
    },
    // 关闭资产类型选择页面
    handleToFollowCancleFloat () {
      document.body.style.overflow = 'auto'
      this.assetsTypeFlag = false
    },
    // 选择跟进方式
    handleToSelectVisitMode (val) {
      document.body.style.overflow = 'auto'
      this.assetsTypeFlag = false
      const Objdata = this.assetsTypeList.filter(item => item.cnname === val)[0]
      this.assetsType = Objdata.enname
      this.assetsText = Objdata.cnname
    },
    // 添加资产信息
    async handleToAddAssetsCheckNews () {
      const assetsSaveData = {
        assetName: this.assetsName,
        assetLocation: this.assetsLoc,
        assetType: this.assetsType,
        payDebtAmount: this.assetsAmount,
        mmFollowStaffList: this.assetsManagerList
      }
      const result = await postjson('/api/CBMS-APP/mmassetinfo/add', assetsSaveData)
      const routerName = this.$route.params.routerName ? this.$route.params.routerName : ''
      if (result.success) {
        this.$toast.success({
          message: '新增资产添加成功',
          onClose: () => {
            if (routerName) {
              this.$router.push({ name: routerName })
            } else {
              this.$router.push('/homeassets')
            }
          }
        })
      } else {
        this.$toast.success('新增资产添加失败')
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addmarket
  position : relative
  width : 100vw
  overflow-x : hidden
  overflow-y : scroll
  .addmarket--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addmarket--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 0 16px
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
    .addmarket--header--text
      box-sizing : border-box
      width : 100%
      display : flex
      background : #f7f7f7
      padding : 26.5px 16px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
  .header-line
    height : 100px
    width : 100%
  .addmarket--info
    .addmarket--info--name
      display : flex
      align-items : center
      margin : 0 16px
      padding : 16px 0
      border-bottom : 1px solid #8b8787
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &.active
        border : 1px solid #b45858
      .item--name
        width : 150px
        line-height : 47px
      .item--icon
        width : 120px
        text-align : right
        padding-right : 16px
        line-height : 47px
        font-size: 48px
        color : #4282e1
      .item--img--icon
        text-align : center
        line-height : 48px
        font-size: 48px
        color : #4282e1
        &>>>.van-uploader__upload
          height : 47px
          background-color : #ffffff
          margin : 0
        &>>>.van-uploader__upload-icon
          color : #4282e1
          font-size: 48px
      .item--ipt
        flex : 1
        height : 32px
        padding : 16px 0 16px 16px
        border: none;
        border-radius: 8px
        outline : none
        margin : 0 16px
        &:focus
          border-color: #4282e1
          outline: none
        &:disabled
          background-color : #ffffff
          color: #000000
          opacity:1
      .item--area
        flex : 1
        padding : 0 0 16px 16px
        border: none;
        border-radius: 8px
        outline : none
        margin : 0 16px
        overflow: hidden;
        resize : none
        &::placeholder
          line-height : 130px
        &:focus
          border-color: #4282e1
          outline: none
        &:disabled
          background-color : #ffffff
          color: #000000
          opacity:1
      .item--address
        flex : 1
        margin-left : 16px
        padding : 16px 16px 16px 16px
        line-height : 47px
    .addfollowup--info--person
      padding : 16px
      line-height : 1.5
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .item--persons--title
        padding : 0 0 16px 0
        border-bottom : 1px solid #8b8787
      .item--persons--desc
        display : flex
        align-items : center
        padding : 16px 0
        border-bottom : 1px solid #8b8787
        .desc--person
          background-color : #4282e1
          margin-right : 32px
          width : 100px
          height : 100px
          line-height : 100px
          text-align : center
          border-radius : 50%
          color : #ffffff
          font-family: MyriadPro-Regular
          font-size: 28px
          font-weight: normal
          font-stretch: normal
        .desc--person--plus
          font-size : 32px
    .addfollowup--info--item
      display : flex
      justify-content : center
      align-items : center
      margin : 0 16px
      padding : 16px 0
      line-height : 1.5
      border-bottom : 1px solid #8b8787
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &:nth-child(1)
        margin-top : 0
      .item--text
        width : 200px
      .item--desc
        flex : 1
        text-align : left
        text-indent : 32px
      .item--report
        flex : 1
        text-align : right
        color : #007aff
        text-decoration: underline
      .item--radio
        flex : 1
        &>>>.van-radio-group
          padding-left : 16px
      .item--icon
        width : 100px
        text-align : right
        font-size: 34px
        color : #4282e1
      &>>>.md-field-item
        width : 100vw
      &>>>.md-field-item-content:before
        border-bottom : none
  .addfollowup--footer
    position : fixed
    left : 0
    bottom :0
    width : 100vw
    display : flex
    z-index : 100
    .addfollowup--footer--save
      flex : 1
      text-align : center
      padding : 32px 0
      background-color : #eabf62
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
  .addfollowup--visit
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .visit--title
      position : fixed
      top: 0
      left: 0
      width : 100vw
      z-index : 12
      display : flex
      background-color : #687591
      .visit--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .visit--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
        color : #ffffff
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
        color : #ffffff
    .visit--line
      height : 80px
    .visit--item
      display : flex
      align-items : center
      margin : 16px 32px 0 32px
      border-radius : 12px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      border : 1px solid #007aff
      color: #333333
      .visit--item--icon
        padding : 16px
        width : 48px
        color: #4282e1
      .visit--item--text
        flex : 1
        padding: 16px
        text-align : left
        .text-title
          padding-bottom : 8px
          font-size: 32px
          font-weight: normal
          font-stretch: normal
        .text-desc
          padding-top : 8px
          color : #007aff
    .visit--person
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .visit--person--content
        width : calc(25% - 16px)
        padding : 16px 0
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        text-align : center
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
</style>
